export default __webpack_public_path__ + "static/media/external.ab8da880.png";